import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { SCHOOL_LIST } from "./apiRoutes";

export interface SchoolItem {
  id: string;
  schoolName: string;
  contactNo?: string;
  state?: string;
  city?: string;
  onboardingDate?: string | null;
  active?: boolean;
}

export interface SchoolsResponse {
  data: any;
  meta?: {
    total_records?: number;
    total_pages?: number;
    page?: number;
    limit?: number;
  };
}

const fetchSchools = async ({ params }: { params: FieldValues }) => {
  const response = await axiosAuth.get<SchoolsResponse>(SCHOOL_LIST, {
    params,
  });
  return response.data;
};

export const useGetSchoolsQuery = (
  params: FieldValues,
  queryParams?: UseQueryOptions<SchoolsResponse, Error, SchoolsResponse, ["schools", FieldValues]>
) =>
  useQuery<SchoolsResponse, Error, SchoolsResponse, ["schools", FieldValues]>({
    queryKey: ["schools", params],
    queryFn: () => fetchSchools({ params }),
    ...(queryParams as any),
  });


